import React, { useMemo, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import shortid from 'shortid'

// import styles from '../component-styles/site-selector.module.scss'
import SelectBoxTypeahead from './select-box-typeahead'
import { getSelectedAccountAsync, switchAccountAsync } from '../store/actions'
import { sortData } from '../helpers'
import { GraphQLState } from '../store/graphql-reducer'
import { SiteState } from '../store/site-reducer'

const getIconPath = (homepage: string | null): string => {
  return homepage
    ? `https://www.google.com/s2/favicons?domain=${homepage}`
    : `/favicon.png`
}

export default function SiteSelector({
  className,
}: {
  className?: string
}): React.ReactElement {
  const dispatch = useDispatch()
  const {
    graphql: { currentUser },
    site: { selected },
  }: {
    graphql: GraphQLState
    site: SiteState
  } = useSelector((s: any): any => s)

  const { userAccountProfiles } = currentUser || {}

  const [selectedValue, setSelectedValue] = useState(selected || null)
  const [selValue, setSelValue] = useState(selected?.accountID || '')
  const [icon, setIcon] = useState(getIconPath(selected?.homepage || ''))

  const labelList = useMemo(() => {
    if (!userAccountProfiles) {
      return []
    }
    const acc = {}
    userAccountProfiles.forEach((item) => {
      const useAcc = acc[item.companyID] ? acc[item.companyID].acctIDs : []
      acc[item.companyID] = {
        title: item.companyName,
        acctIDs: [...useAcc, item.accountID],
      }
    })
    const list = Object.keys(acc).map((key) => {
      return { title: acc[key].title, items: acc[key].acctIDs }
    })
    return sortData(list, 'title', true, null, true)
  }, [userAccountProfiles])

  useEffect((): void => {
    if (selected) {
      setSelectedValue(selected)
      setSelValue(selected?.accountID || '')
      setIcon(getIconPath(selected?.homepage))
    }
    // eslint-disable-next-line
  }, [selected, selectedValue])

  useEffect((): void => {
    if (selected) {
      setIcon(getIconPath(selected?.homepage))
    }
    // eslint-disable-next-line
  }, [selected])

  useEffect((): void => {
    if (!selected) {
      dispatch(getSelectedAccountAsync())
    }
    // eslint-disable-next-line
  }, [selected])

  const list = useMemo(() => {
    if (!userAccountProfiles) {
      return []
    }
    const res = userAccountProfiles.map((item) => {
      const { accountID, accountName: name, homepage } = item
      return {
        accountID,
        name,
        icon: getIconPath(homepage),
      }
    })
    return res
  }, [userAccountProfiles])

  if (
    selValue === '' ||
    !userAccountProfiles ||
    userAccountProfiles.length === 0
    // (accountList && accountList.length === 1 && accountList[0].preSetup)
  ) {
    return <></>
  }

  // const otherAccounts = accountList && accountList.length > 0
  // {!otherAccounts && <h4>No other sites found.</h4>}
  const key = selectedValue?.accountName || shortid.generate()
  return (
    <div className={className}>
      <SelectBoxTypeahead
        key={`${key}${icon}`}
        id="site-selector"
        placeholder="Select value or start typing"
        onInputChange={(value: string): void => {
          // eslint-disable-next-line
          // debugger
          setSelValue(value)
          if (selectedValue && selectedValue.accountID !== value) {
            dispatch(switchAccountAsync(value))
            setIcon(getIconPath(null))
          }
        }}
        value={selValue}
        showDefault
        keyName="name"
        keyValue="accountID"
        labels={labelList}
        iconKey="icon"
        icon={icon}
        items={list}
        sort="asc"
      />
    </div>
  )
}
